import React, { useState, useEffect } from 'react';
import { LogIgnore } from '../../shared/log';
import { DateTime } from 'luxon';
import { LoaderFunction, useLoaderData, useLocation, useNavigate, useNavigation, useParams } from 'react-router';
import { getLogIgnoreById } from '../../shared/client';
import LogIgnoreFormInternal from './log-ignore-add-or-update';

export const loader: LoaderFunction = async ({ request, params }) => {
    const id = params["id"] as string;
    const module = params["module"] as string;
    return await getLogIgnoreById(id, module);
}

export const LogIgnoreFormUpdate: React.FC = () => {
    const intialLogFilter: LogIgnore = {
        id: "",
        keyword: undefined,
        comment: undefined,
        active: false,
        createdAt: DateTime.now(),
        updatedAt: undefined
    }

    const [logIgnore, setLogIgnore] = useState<LogIgnore>(intialLogFilter);
    const location = useLocation();
    const navigate = useNavigate();
    const { module, id } = useParams();
    const navigation = useNavigation();
    const _logIgnore = useLoaderData() as LogIgnore;

    useEffect(() => {
        if (id) {
            setLogIgnore(_logIgnore)
        }
    }, [_logIgnore, id])

    const handleSaveLogIgnore = (data: LogIgnore) => {
        console.log('Saved LogIgnore:', data);
        if (!id) {
            setLogIgnore(data);
        }
    };

    return (
        <LogIgnoreFormInternal initialData={logIgnore} isDisplayOnly={false} onSave={handleSaveLogIgnore} />
    );
};

export default LogIgnoreFormUpdate